module.exports = __webpack_public_path__ + "static/media/Portrait-10221.5e1a78d3.jpg";